<template>
  <div class="new-leads-page">
    <NewLeads />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NewLeads from "@/components/Pages/CRM/NewLeads/index.vue";

export default defineComponent({
  name: "NewLeadsPage",
  components: {
    NewLeads,
  },
});
</script>

<style scoped>
.new-leads-page {
  min-height: 100vh;
  background: #f8fafc;
}
</style> 
